// utils/loadImageBase64.js
// export const loadImageBase64 = (url) => {
//     return new Promise((resolve, reject) => {
//       const xhr = new XMLHttpRequest();
//       xhr.onload = function () {
//         const reader = new FileReader();
//         reader.onloadend = () => resolve(reader.result);
//         reader.readAsDataURL(xhr.response);
//       };
//       xhr.onerror = reject;
//       xhr.open('GET', url);
//       xhr.responseType = 'blob';
//       xhr.send();
//     });
//   };
  

export async function loadImageBase64(url) {
  if (!url) return null;
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Cannot fetch image');
    const blob = await response.blob();
    const reader = new FileReader();
    return await new Promise((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result); // ✅ data:image/png;base64,...
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('❌ Error loading image:', url, error);
    return null;
  }
}